( function () {
	'use strict';
	/* eslint max-params:0 */
	/* eslint-disable max-params */
	/* eslint-disable no-use-before-define */
	function Observations ( $q, dataservice, logger, $modal, apiService, Session, $location, moment, persistence, createObsService, $routeParams, observationService ) {
		var self    = this;

		self.title  = 'Observations';
		self.navs   = [ 'In Progress', 'In Review', 'Completed by Me', 'Completed by Others' ];
		self.active = persistence.observationsActiveList;

		// variables for calendar and date filtering
		self.dateInfo = observationService.dateInfo;

		self.dateInfo.startDate = self.dateInfo.startDate || moment().subtract( 90, 'days' ).format();
		self.dateInfo.endDate   = self.dateInfo.endDate || moment().add( 90, 'days' ).format();

		self.maxDate     = moment().format();
		self.minDate     = moment().subtract( 3650, 'days' ).format();
		self.endOpened   = false;
		self.startOpened = false;

		self.dateOptions = {
			'formatYear'  : 'yyyy',
			'startingDay' : 0,
			'showWeeks'   : false
		};

		self.formats = [ 'MM/dd/yy' ];
		self.format  = self.formats[ 0 ];

		self.disableTeacher = true;
		self.templates      = [];

		self.status = {
			'isopen' : false
		};

		var preloadData = $q.all( [
			createObsService.getTemplates(),
			createObsService.getFavoriteTemplates(),
			createObsService.getSchoolsAndUsers()
		] );

		createObsService.savePreLoadedData( preloadData );

		function activate () {
			logger.info( 'Activated Observations View' );

			if ( $routeParams.selfobs ) {
				openModal( 1 );
			}
		}

		function changeFilter ( filter ) {
			self.searchFilter = filter;
		}

		// methods and settings for the datepicker
		function startOpen ( $event ) {
			$event.preventDefault();
			$event.stopPropagation();

			self.startOpened = !self.startOpened;
			self.endOpened   = false;
		}

		function endOpen ( $event ) {
			$event.preventDefault();
			$event.stopPropagation();

			self.endOpened   = !self.endOpened;
			self.startOpened = false;
		}

		function updatePersistence ( newValue ) {
			persistence.observationsActiveList = newValue;
		}

		function openModal ( type ) {
			self.endOpened    = false;
			self.startOpened  = false;
			self.shouldBeOpen = true;
			var templateUrl = '/templates/observations/observation-start/start-obs-modal.html';

			// setting type = 1 for self obs
			if ( type === 1 ) {
				templateUrl = '/templates/observations/observation-start/self-obs-modal.html';
			}
			var modalInstance = $modal.open( {
				'templateUrl'  : templateUrl,
				'controller'   : 'StartObsModalCtrl',
				'controllerAs' : 'vm',
				'keyboard'     : false
			} );

			modalInstance.result.then( function ( res ) {
				var url = '/observations/' + res.id + '/edit';

				$location.path( url );
			} );
		}

		self.changeFilter      = changeFilter;
		self.updatePersistence = updatePersistence;
		self.openModal         = openModal;
		self.startOpen         = startOpen;
		self.endOpen           = endOpen;

		activate();
	}

	angular
		.module( 'app.observations' )
		.controller( 'Observations', Observations );

	Observations.$inject = [ '$q', 'coreservice', 'logger', '$modal', 'apiService', 'Session', '$location', 'moment', 'persistence', 'createObsService', '$routeParams', 'observationService' ];
} )( );
